<template>
  <div>
    <!-- NAVBAR -->
    <div>
      <Navbar />
    </div>
    <!-- SLIDER -->
    <div class="mt-2 bg-geometria pt-10" v-if="homeData">
      <Slider
        :sliders="(homeData.sliders || []).filter(({ status }) => status)"
      />
    </div>
  </div>
  <template v-if="homeData">
    <!--CATEGORIES-->
    <div class="mt-24 mb-4">
      <!-- CATEGORIES -->
      <h1
        class="text-center font-semibold text-theme-9 text-3xl mb-6 font-crimson_pro"
      >
        Categorías
      </h1>
      <div
        class="flex flex-row justify-between items-center w-full container mx-auto p-1"
      >
        <button
          class="hidden md:flex justify-center items-center w-[40px] h-[40px] bg-[#F1F1F1] rounded-[4px] hover:bg-[#ffde89] hover:text-white"
          @click="displaceCategoriesSlider('left')"
        >
          <p class="text-xl font-bold text-center">&lt;</p>
        </button>
        <div
          class="flex flex-row justify-between items-center w-full container mx-auto p-1 md:overflow-x-auto"
          ref="categoriesSlider"
        >
          <div class="flex flex-row justify-center flex-wrap md:flex-nowrap">
            <div
              class="flex"
              v-for="(category, index) in homeData.categories"
              :key="index"
            >
              <div
                class="flex flex-col justify-center w-[200px] h-[200px] my-1 md:my-0 md:mx-1 border-[3px] border-white rounded-3xl cursor-pointer"
                @click="
                  $router.push({
                    name: 'catalogue',
                    query: { categoryId: category.id }
                  })
                "
              >
                <div
                  class="flex place-self-center justify-center items-center w-[150px] h-[150px]"
                >
                  <img
                    :src="category.image"
                    alt="category"
                    class="w-full mx-auto rounded-3xl h-full object-fill"
                  />
                </div>
                <p class="text-center font-bold text-[#E85C04] my-1">
                  {{ category.name }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <button
          class="hidden md:flex justify-center items-center w-[40px] h-[40px] bg-[#F1F1F1] rounded-[4px] hover:bg-[#ffde89] hover:text-white"
          @click="displaceCategoriesSlider('right')"
        >
          <p class="text-xl font-bold text-center">&gt;</p>
        </button>
      </div>
    </div>
    <div class="backtest mb-12" v-if="homeData.banner?.status">
      <div class="lg:bg-banner-cot sm:bg-banner-cot-res">
        <!-- BANNER -->
        <div class="grid grid-cols-3 gap-4 container rounded-2xl bg-banner">
          <div class="col-span-3 sm:col-span-2 p-2 sm:p-2 m-auto">
            <h1
              class="font-semibold text-3xl text-theme-4 text-center sm:text-left font-crimson_pro"
            >
              {{ homeData.banner.title }}
            </h1>
            <p
              class="font-normal text-base my-2 text-center sm:text-left font-poppins"
            >
              {{ homeData.banner.description }}
            </p>
            <div class="text-center sm:text-left pt-2 sm:pt-0">
              <router-link
                :to="{
                  name: 'catalogue',
                  query: { temporalityId: homeData.banner.category_id }
                }"
                v-slot="{}"
              >
                <button
                  class="m-auto sm:m-0 h-12 rounded text-white hover:scale-110 btn-deg font-poppins"
                >
                  Ver productos
                </button>
              </router-link>
            </div>
          </div>
          <div class="col-span-3 sm:col-span-1 p-2 sm:p-2 m-auto">
            <img
              :src="homeData.banner.image[0]"
              alt="imagen del banner"
              class="h-48 object-contain object-center w-full"
              crossorigin="anonymous"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="bg-products-cot h-auto mb-12" style="height: auto !important">
      <div class="container">
        <!-- OUR PRODUCTS -->
        <h1
          class="text-center font-semibold text-theme-9 text-3xl mb-6 font-crimson_pro"
        >
          Nuestros productos
        </h1>
        <div class="grid grid-cols-3 gap-4 mb-4">
          <div class="sm:col-span-2 col-span-3 font-poppins">
            <p>
              Contamos con una gran variedad de productos para tu negocio y
              clientes. Visita nuestro catálogo para ver las novedades que
              tenemos para ti.
            </p>
          </div>
          <div class="m-auto sm:col-span-1 col-span-3">
            <router-link :to="{ name: 'catalogue' }" v-slot="{}">
              <button
                class="m-auto sm:m-0 h-12 w-60 rounded text-white hover:scale-110 btn-deg font-poppins"
              >
                Ir al catálogo
              </button>
            </router-link>
          </div>
        </div>
        <div class="container mx-auto">
          <div
            class="sm:grid sm:grid-rows-2 sm:grid-flow-col sm:gap-4 contents"
          >
            <div class="row-span-3 sm:mb-0 mb-4">
              <div class="sm:row-span-2 row-auto h-auto m-0 text-center">
                <div style="border: 3px solid #ffffff47; border-radius: 24px">
                  <img
                    src="@/assets/images/COT-img/eventos/Verano-1.svg"
                    style="height: auto; margin: auto"
                    alt="image"
                  />
                  <h1
                    class="py-3 text-base font-bold text-theme-6 font-poppins"
                  >
                    Todos los productos para el<span
                      class="py-3 pl-1 text-base font-bold text-theme-28 font-poppins"
                      >verano</span
                    >
                  </h1>
                </div>
              </div>
            </div>
            <div class="row-span-1 col-span-2 sm:mb-0 mb-4">
              <div class="grid grid-cols-2 gap-4">
                <div class="sm:col-span-1 col-span-2 text-center">
                  <div
                    style="
                      border: 3px solid rgba(255, 255, 255, 0.28);
                      border-radius: 24px;
                    "
                  >
                    <img
                      src="@/assets/images/COT-img/eventos/school.svg"
                      alt="image"
                      style="margin: auto !important"
                    />
                    <h1
                      class="py-3 text-base font-bold text-theme-6 font-poppins"
                    >
                      Lo último para el
                      <span
                        class="py-3 pl-1 text-base font-bold text-theme-28 font-poppins"
                        >regreso a clases</span
                      >
                    </h1>
                  </div>
                </div>
                <div class="sm:col-span-1 col-span-2 text-center">
                  <div style="border: 3px solid #ffffff47; border-radius: 24px">
                    <img
                      src="@/assets/images/COT-img/eventos/cocina.svg"
                      alt="image"
                      style="margin: auto !important"
                    />
                    <h1
                      class="py-3 text-base font-bold text-theme-6 font-poppins"
                    >
                      Los mejores productos de
                      <span
                        class="py-3 pl-1 text-base font-bold text-theme-28 font-poppins"
                        >cocina</span
                      >
                    </h1>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="row-span-2 col-span-2 sm:mb-0 mb-4"
              style="
                border: 3px solid rgba(255, 255, 255, 0.28);
                border-radius: 24px;
              "
            >
              <div class="w-full lg:max-w-full lg:flex">
                <div
                  class="h-48 lg:h-44 lg:w-1/2 flex-none bg-cover rounded-t lg:rounded-t-none lg:rounded-l text-center overflow-hidden eventos bg-center"
                ></div>
                <div class="p-4 flex flex-col justify-between leading-normal">
                  <div class="m-auto">
                    <div class="font-bold text-base">
                      <h1
                        class="py-3 text-base font-bold text-theme-6 font-poppins"
                      >
                        Empieza a planear tus
                        <span
                          class="py-3 pl-1 text-base font-bold text-theme-28 font-poppins"
                          >fiestas patrias</span
                        >
                        con nuestros promocionales
                      </h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container mx-auto">
      <!-- SERVICES -->
      <h1
        class="text-center font-semibold text-theme-9 text-3xl mb-6 font-crimson_pro"
      >
        Servicios
      </h1>
      <p class="text-center font-poppins">
        Somos una consultora de marketing y creamos valor para nuestros clientes
        colocando su inversión y marca donde debe estar mediante estrategias
        integrales y efectivas. Para más información no dudes en contactarnos.
      </p>
      <div class="grid grid-cols-3 gap-4 my-6">
        <div
          class="sm:mx-2 md:mx-10 mx-12 md:w-52 lg:w-64 h-64 rounded-3xl sm:col-span-1 col-span-3 flip-card"
        >
          <div class="flip-card-inner">
            <div class="flip-card-front p-7">
              <img
                src="@/assets/images/COT-img/cards/A.svg"
                alt="Avatar"
                style="width: 70%; height: 70%; margin: 8% auto"
              />
              <h1 class="font-bold text-base text-theme-28 font-poppins">
                Brand In Premiums
              </h1>
            </div>
            <div class="flip-card-back p-7 font-poppins">
              <p
                style="
                  display: flex !important;
                  justify-content: center !important;
                  align-items: center !important;
                  height: 100% !important;
                "
              >
                Activa tu marca con productos que crean experiencias de compra
                memorables e impactantes.
              </p>
            </div>
          </div>
        </div>
        <div
          class="sm:mx-2 md:mx-10 mx-12 md:w-52 lg:w-64 h-64 rounded-3xl sm:col-span-1 col-span-3 flip-card"
        >
          <div class="flip-card-inner">
            <div class="flip-card-front p-7">
              <img
                src="@/assets/images/COT-img/cards/B.svg"
                alt="Avatar"
                style="width: 70%; height: 70%; margin: 8% auto"
              />
              <h1 class="font-bold text-base text-theme-28 font-poppins">
                Brand In Premiums
              </h1>
            </div>
            <div class="flip-card-back p-7 font-poppins">
              <p
                style="
                  display: flex !important;
                  justify-content: center !important;
                  align-items: center !important;
                  height: 100% !important;
                "
              >
                Brindamos experiencias únicas a través de nuestra plataforma y
                planes de recompensa.
              </p>
            </div>
          </div>
        </div>
        <div
          class="sm:mx-2 md:mx-10 mx-12 md:w-52 lg:w-64 h-64 rounded-3xl sm:col-span-1 col-span-3 flip-card"
        >
          <div class="flip-card-inner">
            <div class="flip-card-front p-7">
              <img
                src="@/assets/images/COT-img/cards/C.svg"
                alt="Avatar"
                style="width: 70%; height: 70%; margin: 8% auto"
              />
              <h1 class="font-bold text-base text-theme-28 font-poppins">
                Brand In Premiums
              </h1>
            </div>
            <div class="flip-card-back p-7 font-poppins">
              <p
                style="
                  display: flex !important;
                  justify-content: center !important;
                  align-items: center !important;
                  height: 100% !important;
                "
              >
                Aprovecha las estrategias a través de las tecnologías online
                para llevar tu marca a las personas indicadas.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="false" class="mt-12">
      <!-- OUR ALIADES -->
      <h1
        class="text-center font-semibold text-theme-9 text-3xl mb-6 font-crimson_pro"
      >
        Nuestros aliados
      </h1>
      <div class="mx-0 mb-12">
        <TinySlider
          :options="{
            autoplay: true,
            controls: false,
            items: 1,
            responsive: {
              600: {
                items: 4
              },
              480: {
                items: 2
              }
            }
          }"
          style="
            background: linear-gradient(
              111.68deg,
              rgba(255, 255, 255, 0.29) 7.59%,
              rgba(255, 255, 255, 0.39) 102.04%
            );
            border: 3px solid rgba(255, 255, 255, 0.35);
          "
        >
          <div class="h-32 px-2">
            <div class="h-full bg-slate-100 dark:bg-darkmode-400 rounded-md">
              <h3
                class="h-full font-medium flex items-center justify-center text-2xl"
              >
                <img
                  src="@/assets/images/COT-bg/aliados/bimbo.svg"
                  alt="empresa1"
                />
              </h3>
            </div>
          </div>
          <div class="h-32 px-2">
            <div class="h-full bg-slate-100 dark:bg-darkmode-400 rounded-md">
              <h3
                class="h-full font-medium flex items-center justify-center text-2xl"
              >
                <img
                  src="@/assets/images/COT-bg/aliados/Meridian.svg"
                  alt="empresa1"
                />
              </h3>
            </div>
          </div>
          <div class="h-32 px-2">
            <div class="h-full bg-slate-100 dark:bg-darkmode-400 rounded-md">
              <h3
                class="h-full font-medium flex items-center justify-center text-2xl"
              >
                <img
                  src="@/assets/images/COT-bg/aliados/Movistar.svg"
                  alt="empresa1"
                />
              </h3>
            </div>
          </div>
          <div class="h-32 px-2">
            <div class="h-full bg-slate-100 dark:bg-darkmode-400 rounded-md">
              <h3
                class="h-full font-medium flex items-center justify-center text-2xl"
              >
                <img
                  src="@/assets/images/COT-bg/aliados/Exxonmobil.svg"
                  alt="empresa1"
                />
              </h3>
            </div>
          </div>
          <div class="h-32 px-2">
            <div class="h-full bg-slate-100 dark:bg-darkmode-400 rounded-md">
              <h3
                class="h-full font-medium flex items-center justify-center text-2xl"
              >
                <img
                  src="@/assets/images/COT-bg/aliados/Sigma.svg"
                  alt="empresa1"
                />
              </h3>
            </div>
          </div>
          <div class="h-32 px-2">
            <div class="h-full bg-slate-100 dark:bg-darkmode-400 rounded-md">
              <h3
                class="h-full font-medium flex items-center justify-center text-2xl"
              >
                <img
                  src="@/assets/images/COT-bg/aliados/logo-klassco_2_.svg"
                  alt="empresa1"
                  width="200"
                />
              </h3>
            </div>
          </div>
        </TinySlider>
      </div>
    </div>
    <div class="sm:mb-2 mb-20 bg-help mt-16">
      <!-- HELP -->
      <div class="grid grid-cols-3 gap-4 container">
        <div class="sm:col-span-2 col-span-3 text-center sm:text-left">
          <h1
            class="sm:text-left text-center font-semibold text-theme-9 text-3xl mb-6 font-crimson_pro"
          >
            ¿Necesitas ayuda?
          </h1>
          <p class="mb-6 text-base font-poppins">
            Entra a nuestra sección de ayuda donde te contamos más de cómo
            funciona nuestro cotizador.
          </p>
          <router-link :to="{ name: 'help' }" v-slot="{}">
            <button
              class="m-auto sm:m-0 h-12 rounded text-white hover:scale-110 btn-deg font-poppins"
            >
              Ir a ayuda
            </button>
          </router-link>
        </div>
        <div class="sm:col-span-1 col-span-3">
          <img
            src="@/assets/images/COT-img/key.png"
            class="h-56 m-auto sm:m-0"
            alt="image"
          />
        </div>
      </div>
    </div>
    <div>
      <Footer />
    </div>
  </template>
</template>

<script>
import Navbar from '@/components/navbar/Main.vue'
import Slider from '@/components/slider/Main.vue'
import Footer from '@/components/footer/Main.vue'
import { cleanSession, getFirstErrorMessage } from '@/utils/tools'
export default {
  components: {
    Navbar,
    Slider,
    Footer
  },
  data() {
    return {
      homeData: undefined
    }
  },

  async beforeMount() {
    this.$store.commit('main/setShowSpinner', true)
    await this.getHomeData()
    this.$store.commit('main/setShowSpinner', false)
  },
  methods: {
    async getHomeData() {
      try {
        const response = await this.axios.get('sales-operator/home/data', {
          headers: {
            Authorization: `Bearer ${this.$store.state.auth.token}`
          }
        })
        this.homeData = response.data || {
          categories: [],
          sliders: [],
          banner: undefined
        }
      } catch (error) {
        if (error?.response?.status === 401) {
          this.$toast.error('Su sesión ha expirado', {
            position: 'top'
          })
          return cleanSession(this.$store, this.$router)
        }
        this.$toast.error(getFirstErrorMessage(error), {
          position: 'top'
        })
      }
    },
    displaceCategoriesSlider(direction) {
      let withScroll = this.$refs.categoriesSlider.scrollLeft
      if (direction == 'left') {
        withScroll -= 100
      }

      if (direction == 'right') {
        withScroll += 100
      }

      this.$refs.categoriesSlider.scrollTo(withScroll, 0)
    }
  }
}
</script>

<style scoped>
/*
html {
  background: url('@/assets/images/COT-img/COT-background.svg') no-repeat center
    center fixed;
  background-size: cover;
  background: #f1eae9;
}

body {
  background: #f1eae9;
}
*/

.bg-categories {
  background: linear-gradient(
    90deg,
    rgba(241, 236, 237, 1) 0%,
    rgb(250 163 6 / 4%) 50%,
    rgba(241, 236, 237, 1) 100%
  );
  margin: 0;
}

.bg-nav {
  background: url('@/assets/images/COT-bg/img-slider-nav.svg');
  background-repeat: no-repeat;
  /* background-position: 0px center; */
  backface-visibility: hidden;
  height: 600px;
  width: auto;
}

.bg-banner-2 {
  background: url('@/assets/images/COT-bg/img-banner2.svg');
  background-repeat: no-repeat;
  background-position: initial;
  backface-visibility: hidden;
  height: 600px;
  width: auto;
}

.bg-geometria {
  background: url('@/assets/images/COT-bg/img-geometria.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  height: 507px;
  width: auto;
}

.bg-cat-bg {
  background: url('@/assets/images/COT-bg/img-categorias.svg');
  background-repeat: no-repeat;
  background-position: center;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  height: 230px;
  width: auto;
  padding-top: 2px;
}

.bg-banner {
  background: linear-gradient(
    111.68deg,
    rgba(255, 255, 255, 0.29) 7.59%,
    rgba(255, 255, 255, 0.39) 102.04%
  );
  backdrop-filter: blur(8px) brightness(100%);
  border: 3px solid rgba(255, 255, 255, 0.28);
}

.backtest {
  background: url('@/assets/images/COT-bg/img-banner2.svg');
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: cover;
}

.bg-banner-cot {
  background: url('@/assets/images/COT-bg/img-banner2.svg');
  background-repeat: no-repeat;
  background-position: center;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  height: 198px;
  width: auto;
  padding-top: 0px;
  margin-bottom: 18rem;
}

.bg-banner-cot-res {
  background: url('@/assets/images/COT-bg/img-banner2.svg');
  background-repeat: no-repeat;
  background-position: center;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  height: 445px;
  width: auto;
  padding-top: 0px;
}

.bg-products-cot {
  background: url('@/assets/images/COT-bg/img-products.svg');
  background-repeat: no-repeat;
  background-position: inherit;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  height: 230px;
  width: auto;
  padding-top: 2px;
}

.bg-help {
  background: url('@/assets/images/COT-bg/img-help.svg');
  background-repeat: no-repeat;
  background-position: right;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  height: 350px;
  width: auto;
  padding-top: 2px;
}

.btn-deg {
  background: linear-gradient(89.75deg, #e85c04 0.17%, #faa306 99.78%);
  transition: 0.3s;
  outline: 1px solid transparent;
  width: 200px;
  font-weight: 600;
}

.b-cot-card {
  background-image: radial-gradient(
      circle at 100% 100%,
      transparent 18px,
      #ffffff 18px,
      #ffffff 21px,
      transparent 21px
    ),
    linear-gradient(to right, #ffffff, #ffffff),
    radial-gradient(
      circle at 0% 100%,
      transparent 18px,
      #ffffff 18px,
      #ffffff 21px,
      transparent 21px
    ),
    linear-gradient(to bottom, #ffffff, #f6f6e0),
    radial-gradient(
      circle at 0% 0%,
      transparent 18px,
      #ffffff21 18px,
      #ffffff21 21px,
      transparent 21px
    ),
    linear-gradient(to left, #ffffff21, #ffffff21),
    radial-gradient(
      circle at 100% 0%,
      transparent 18px,
      #ffffff21 18px,
      #ffffff21 21px,
      transparent 17px
    ),
    linear-gradient(to top, #ffffff21, #ffffff);
  background-size: 21px 21px, calc(100% - 42px) 3px, 21px 21px,
    3px calc(100% - 42px);
  background-position: top left, top center, top right, center right,
    bottom right, bottom center, bottom left, center left;
  background-repeat: no-repeat;
  border-radius: 24px;
}

.bg-card {
  background: #ffffff21;
  border-radius: 24px;
}

.eventos {
  background-image: url('@/assets/images/COT-img/eventos/fiestas-1.svg');
}

.flip-card {
  background-color: transparent;
  perspective: 1000px;
}

.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
}

.flip-card:hover .flip-card-inner {
  transform: rotateY(180deg);
}

.flip-card-front,
.flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.flip-card-front {
  background: linear-gradient(
    111.68deg,
    rgba(255, 255, 255, 0.29) 7.59%,
    rgba(255, 255, 255, 0.39) 102.04%
  );
  border: 3px solid rgba(255, 255, 255, 0.28);
  backdrop-filter: blur(22px);
  /* Note: backdrop-filter has minimal browser support */
  border-radius: 20px;
}

.flip-card-back {
  background: linear-gradient(
    111.68deg,
    rgba(255, 255, 255, 0.29) 7.59%,
    rgba(255, 255, 255, 0.39) 102.04%
  );
  border: 3px solid rgba(255, 255, 255, 0.28);
  backdrop-filter: blur(22px);
  border-radius: 20px;
  transform: rotateY(180deg);
}

.brandin-card {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: 16px;
}
</style>
